<mat-stepper orientation="horizontal" labelPosition="bottom" [linear]="true" #stepper class="w-100" *ngIf="show">

  <ng-template matStepperIcon="edit">
    <mat-icon>check</mat-icon>
  </ng-template>

  <mat-step
    *ngFor="let step of steps"
    [label]="step.title | translated"
  >
  </mat-step>
</mat-stepper>
